import { useState, useEffect } from "react";
import { AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import { IoIosArrowBack } from "react-icons/io";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NoDataFound from "../src/comps/DatanotFound.png";
import { list } from "@material-tailwind/react";

const API_URL = `${process.env.REACT_APP_BE_MAIN_URL}/ocr/spaces/`;
// Assign color by depth
const getColorByLevel = (level) => {
  switch (level) {
    case 0:
      return "border-t-8 border-red-500";
    case 1:
      return "border-t-8 border-orange-400";
    case 2:
      return "border-t-8 border-blue-500";
    default:
      return "border-t-8 border-green-400";
  }
};
// Build tree from API data
const buildTree = (spaces) => {
  const root = [];

  spaces.forEach((item) => {
    let currentLevel = root;

    for (let i = 1; i <= 8; i++) {
      const key = `level${i}`;
      const name = item[key];

      // Skip null/empty levels
      if (!name) break;

      // Check if this level already exists in the current hierarchy
      let existing = currentLevel.find((node) => node.name === name);
      if (!existing) {
        existing = {
          id: `${item.id}-${i}`,
          name,
          description: "",
          children: [],
        };
        currentLevel.push(existing);
      }

      // Go one level deeper
      currentLevel = existing.children;
    }
  });

  return root;
};


export default function MyDataPage() {
  const [showModal, setShowModal] = useState(false);
  const [spaces, setSpaces] = useState([]);
  const [fileName, setFileName] = useState("");
  const [description, setDescription] = useState("");
  const [parentPath, setParentPath] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handlefolder = (spaceHierarchy) => {
    const selectedSpace = spaceHierarchy[spaceHierarchy.length - 1];
    sessionStorage.setItem("space", selectedSpace);
    history.push("/createfolder", { state: { list: spaceHierarchy } });
  };

  // Fetch spaces on mount
  useEffect(() => {
    fetchSpaces();
  }, []);

  const fetchSpaces = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API_URL,  {

          headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
        }

       

      });
      
      setSpaces(buildTree(res.data));
    } catch (err) {
      console.error("❌ Fetch error:", err);
      toast.error("Failed to load spaces 😢");
    } finally {
      setLoading(false);
    }
  };

  // const handleCreate = async () => {
  //   if (!fileName.trim()) {
  //     toast.warning("⚠️ Please enter a valid space name.");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const payload = {};
  //     parentPath.forEach((name, i) => {
  //       payload[`level${i + 1}`] = name;
  //     });
  //     payload[`level${parentPath.length + 1}`] = fileName.trim();

  //     const res = await axios.post(API_URL, payload);
  //     toast.success("✅ Space created successfully!");
  //     console.log("Created:", res.data);

  //     setFileName("");
  //     setDescription("");
  //     setParentPath([]);
  //     setShowModal(false);
  //     fetchSpaces();
  //   } catch (err) {
  //     console.error("❌ Error creating space:", err);
  //     toast.error("Failed to create space 😢");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleCreate = async () => {

    if (!fileName.trim()) {

      toast.warning("⚠️ Please enter a valid space name.");

      return;

    }

    setLoading(true);

    try {

      const payload = {

        level1: null,

        level2: null,

        level3: null,

        level4: null,

        level5: null,

        level6: null,

        level7: null,

        level8: null,

      };

      parentPath.forEach((name, i) => {

        payload[`level${i + 1}`] = name;

      });

      payload[`level${parentPath.length + 1}`] = fileName.trim();

      console.log("📤 Payload to send:", payload);

      const token = localStorage.getItem("token"); // or cookies, context…

      const res = await axios.post(API_URL, payload, {

          headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem("userToken")}`
        }

       

      });

      toast.success("✅ Space created successfully!");

      setFileName("");

      setDescription("");

      setParentPath([]);

      setShowModal(false);

      fetchSpaces();

    } catch (err) {

      console.error("❌ Error creating space:", err.response?.data || err);

      toast.error("Failed to create space 😢");

    } finally {

      setLoading(false);

    }

  };



  const SpaceNode = ({
    space,
    level = 0,
    path = [],
    // handlefolder,
    // setParentPath,
    // setShowModal,
    // getColorByLevel,
  }) => {
    return (
      <div className="flex flex-col items-center relative w-full">
        {/* Node Card */}
        <div
          className={`bg-white rounded-lg shadow-md w-64 p-4 text-center relative ${getColorByLevel(
            level
          )}`}
        >
          {/* Avatar */}
          <div className="flex justify-center mb-2">
            <img
              src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
              alt="avatar"
              className="w-12 h-12 rounded-full object-cover cursor-pointer"
              onClick={() => handlefolder([...path, space.name])}
            />
          </div>

          {/* Node Info */}
          <h3 className="font-semibold text-lg">{space.name}</h3>
          <p className="text-sm text-gray-500">{space.description || " "}</p>

          {/* Add Button */}
          <button
            className="absolute top-2 right-2 text-gray-700 hover:text-black"
            onClick={() => {
              setParentPath([...path, space.name]);
              setShowModal(true);
            }}
          >
            <AiOutlinePlus size={16} />
          </button>
        </div>

        {/* Render Children if Present */}
        {space.children?.length > 0 && (
          <div className="flex flex-col items-center">
            {/* Vertical connector from parent to children */}
            <div className="w-px h-6 bg-blue-700"></div>

            {/* Horizontal line and child nodes */}
            <div className="relative flex justify-center items-start mt-1">
              {/* Horizontal connector */}
              <div className="absolute top-0 left-0 right-0 h-px bg-red-700"></div>

              {space.children.map((child) => (
                <div
                  key={child.id}
                  className="flex flex-col items-center mx-8 relative"
                >
                  {/* Vertical line from horizontal connector to child */}
                  <div className="w-px h-6 bg-green-700"></div>

                  {/* Recursive child node */}
                  <SpaceNode
                    space={child}
                    level={level + 1}
                    path={[...path, space.name]}
                  // handlefolder={handlefolder}
                  // setParentPath={setParentPath}
                  // setShowModal={setShowModal}
                  // getColorByLevel={getColorByLevel}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 relative">
      {/* Toast Container */}
      <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />

      {/* Loading Overlay */}
      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-yellow-400"></div>
        </div>
      )}

      {/* Header */}
      <header className="flex justify-between items-center p-6 sticky top-0 bg-white shadow-md z-20">
        <div className="flex items-center gap-4">
          <button className="text-xl font-bold">
            <IoIosArrowBack />
          </button>
          <h1 className="text-2xl font-semibold">Organisation Structure</h1>
        </div>

        <div className="flex items-center gap-4">
          <div className="flex items-center border bg-gray-100 rounded px-3 py-2">
            <input
              type="text"
              placeholder="Search"
              className="bg-transparent outline-none text-sm"
            />
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="bg-[#FECF8B] text-black px-6 py-2 rounded-lg font-bold"
          >
            Create Space
          </button>
        </div>
      </header>

      {/* <div className="h-px bg-gray-700 w-full"></div> */}

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center p-6 overflow-y-auto">
        {spaces.length === 0 ? (
          <div className="text-center mt-20">
            <img src={NoDataFound} alt="no-data" className="w-64 mx-auto mb-4" />
            <h2 className="text-3xl font-bold text-gray-700">No Data Found</h2>
          </div>
        ) : (
          <div className="flex space-x-12">
            {spaces.map((space) => (
              <SpaceNode key={space.id} space={space} />
            ))}
          </div>
        )}
      </main>

      {/* Modal */}
      {showModal && (
        <Modal
          title={
            parentPath.length > 0
              ? `Add Sub-Space under ${parentPath.join(" → ")}`
              : "Create Root Space"
          }
          onClose={() => {
            setShowModal(false);
            setParentPath([]);
          }}
          fileName={fileName}
          setFileName={setFileName}
          description={description}
          setDescription={setDescription}
          onCreate={handleCreate}
        />
      )}
    </div>
  );
}

// 🔹 Reusable Modal
const Modal = ({
  title,
  onClose,
  fileName,
  setFileName,
  description,
  setDescription,
  onCreate,
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl shadow-lg w-[400px] p-6 relative">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-gray-600 hover:text-black"
      >
        <AiOutlineClose size={20} />
      </button>
      <h2 className="text-lg font-bold mb-4">{title}</h2>

      <input
        type="text"
        value={fileName}
        onChange={(e) => setFileName(e.target.value)}
        placeholder="Space Name"
        className="w-full mb-3 px-3 py-2 border rounded-md"
      />
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Description"
        rows={3}
        className="w-full mb-4 px-3 py-2 border rounded-md"
      ></textarea>

      <button
        className="w-full bg-[#FECF8B] text-black py-2 rounded-md font-semibold"
        onClick={onCreate}
      >
        Create
      </button>
    </div>
  </div>
);

